import axios from "axios";
import AdManagerFormatEditDialog from "@/components/AdManager/AdManagerFormatEditDialog/AdManagerFormatEditDialog.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerFormats",
  components: { AdManagerFormatEditDialog },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Desktop", value: "desktop" },
        { text: "Mobile", value: "mobile" },
        { text: "Aktionen", value: "actions", sortable: false }
      ],
      dimensionOptions: [
        { title: "Volle Breite, Höhe automatisch", value: "full_width" },
        { title: "Volle Höhe, Breite automatisch", value: "full_height" },
        { title: "Manuell", value: "manual" }
      ],
      formats: [],
      total: 0,
      options: {},
      loading: true,
      loadingOverlay: false,
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      search: "",
      editDialog: false,
      editedItem: null
    };
  },
  computed: {
    currentPrincipal() {
      return this.$store.state?.selectedPrincipal?.id;
    },
    isAdmin() {
      const scopes = this.$store.state.currentUser?.scopes || [];
      return scopes.includes("role:admin") || scopes.includes("role:ad_admin");
    }
  },
  watch: {
    options() {
      this.loadFormats();
    },
    search(val) {
      if (val?.length >= 3) this.loadFormats();
      if (val === "") this.loadFormats();
    },
    async currentPrincipal() {
      this.loadFormats();
    }
  },
  async mounted() {
    this.loadFormats();
  },
  methods: {
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    getSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      return {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy?.[0] || "name",
        direction: sortDesc?.[0] ? "desc" : "asc"
      };
    },
    async loadFormats() {
      this.loading = true;
      const headers = getTokenHeader();
      try {
        const res = await axios.get(
          env.ad_manager_api_client_url + "ad/formats",
          {
            headers,
            params: this.getSearchParams()
          }
        );
        this.formats = res.data || [];
        const count = parseInt(res?.headers?.["x-count"]);
        this.total = isNaN(count) ? this.formats.length : count;
      } catch (e) {
        this.$toast?.error?.("Fehler beim Laden der Formate");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    createItem() {
      this.editedItem = {
        _id: "",
        principal_id: this.currentPrincipal,
        name: "",
        desktop: { dimensions: "full_width", width: null, height: null },
        mobile: { dimensions: null, width: null, height: null }
      };
      this.editDialog = true;
    },
    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    async deleteItem(item) {
      const ok = await this.$confirm?.(
        `Format <b>${item.name}</b> wirklich löschen?`,
        confirmWarningConfig
      );
      if (!ok) return;
      const headers = getTokenHeader();
      try {
        await axios.delete(
          env.ad_manager_api_client_url + "ad/formats/" + item._id,
          {
            headers,
            params: { principal_id: this.currentPrincipal }
          }
        );
        this.$toast?.success?.("Format gelöscht");
        this.loadFormats();
      } catch (e) {
        this.$toast?.error?.("Löschen fehlgeschlagen");
        console.error(e);
      }
    },
    afterSave() {
      this.loadFormats();
      this.$toast?.success?.("Erfolgreich gespeichert");
    },
    close() {
      this.editDialog = false;
      this.$nextTick(() => (this.editedItem = null));
    },
    exportCsv() {
      const rows = [["Name", "Desktop (WxH)", "Mobile (WxH)"]];
      this.formats.forEach(f => {
        rows.push([
          f.name || "",
          this.getDimensions(f?.desktop),
          this.getDimensions(f?.mobile)
        ]);
      });
      const csv = rows
        .map(r => r.map(v => `"${(v + "").replace(/"/g, '""')}"`).join(";"))
        .join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "ad-formats.csv";
      a.click();
      URL.revokeObjectURL(a.href);
    },
    getDimensions(format) {
      if (!format) {
        return "-";
      }
      if (format.dimensions === "manual") {
        return `${format?.width || "-"}x${format?.height || "-"} px`;
      }
      const dimensions = this.dimensionOptions.find(
        dimensions => dimensions.value === format.dimensions
      );
      return dimensions?.title ?? "-";
    }
  }
};
